export class Slick {
    activate() {
        let frontSlider = $('.frontSlider');
        if (frontSlider.length) {
            frontSlider.slick({
                autoplay: true,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 1000,
                autoplaySpeed: 5000,
                dots: true,
                arrows: false,
            });
        }

        let frontNews = $('.frontNews--frontPage .frontNews__items');
        if (frontNews.length) {
            frontNews.slick({
                autoplay: true,
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 3,
                dots: true,
                autoplaySpeed: 10000,
                arrows: false,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 567,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        }

        let newsDiscipline = $('.frontNews--discipline .frontNews__items');
        if (newsDiscipline.length) {
            newsDiscipline.slick({
                autoplay: true,
                infinite: true,
                slidesToShow: 4,
                slidesToScroll: 4,
                dots: true,
                arrows: false,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 567,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        }

        let frontTeam = $('.frontTeam--frontPage .frontTeam__items');
        if (frontTeam.length) {
            frontTeam.slick({
                autoplay: true,
                infinite: true,
                slidesToShow: 4,
                slidesToScroll: 4,
                dots: false,
                arrows: true,
                prevArrow: '<button type="button" class="slick-prev"><i class="fas fa-arrow-left"></i></button>',
                nextArrow: '<button type="button" class="slick-next"><i class="fas fa-arrow-right"></i></button>',
                responsive: [
                    {
                        breakpoint: 1320,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3
                        }
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 567,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        }

        let teamSlick = $('.teamSlick__items');
        if (teamSlick.length){
            teamSlick.slick(this.slickConfig());
        }


        let teamDiscipline = $('.teamDiscipline__items');
        if (window.innerWidth < 768 && teamDiscipline.length){
            teamDiscipline.slick(this.slickConfig());
        }
        window.addEventListener("resize", () =>{
            if (window.innerWidth < 768) {
                if (teamDiscipline.length) {
                    if(!teamDiscipline.hasClass('slick-initialized')){
                        teamDiscipline.slick(this.slickConfig());
                    }
                }
            }else {
                if (teamDiscipline.hasClass('slick-initialized')){
                    teamDiscipline.slick('unslick');
                }
            }
        });


        let frontPartners = $('.frontPartners__items');
        if (frontPartners.length) {
            frontPartners.slick({
                autoplay: true,
                infinite: true,
                slidesToShow: 6,
                slidesToScroll: 6,
                dots: false,
                arrows: true,
                prevArrow: '<button type="button" class="slick-prev"><i class="fas fa-arrow-left"></i></button>',
                nextArrow: '<button type="button" class="slick-next"><i class="fas fa-arrow-right"></i></button>',
                responsive: [
                    {
                        breakpoint: 1320,
                        settings: {
                            slidesToShow: 5,
                            slidesToScroll: 5
                        }
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 4
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3
                        }
                    },
                    {
                        breakpoint: 567,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            arrows: false,
                        }
                    }
                ]
            });
        }
    }

    slickConfig(){
        return {
            autoplay: true,
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 4,
            dots: false,
            arrows: true,
            prevArrow: '<button type="button" class="slick-prev"><i class="fas fa-arrow-left"></i></button>',
            nextArrow: '<button type="button" class="slick-next"><i class="fas fa-arrow-right"></i></button>',
            responsive: [
                {
                    breakpoint: 1320,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 567,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        }
    }
}